import { Routes } from '@angular/router';
import { AuthGuard } from 'src/guards/auth.guard';
import { Notfound } from './pages/notfound/notfound';
import { AppLayout } from './layout/component/app.layout';
import { TrackingClientComponent } from './pages/tracking/tracking-client/tracking-client.component';

export const appRoutes: Routes = [
    {
        path: '',
        children: [
            {
                path: 'auth',
                loadChildren: () => import('./pages/auth/auth.routes')
            },
            {
                path: '',
                redirectTo: 'auth/login',
                pathMatch: 'full'
            }
        ]
    },
    {
        component: TrackingClientComponent,
        path: 'rastreio/:token',
    },
    {
        component: AppLayout,
        canActivate: [AuthGuard],
        path: 'app',
        loadChildren: () => import('./pages/pages.routes')
    },
    {
        path: 'notfound',
        component: Notfound
    },
    {
        path: '**',
        redirectTo: '/notfound'
    }
];
